import React from "react";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);
import TooltipGraphBarComposed from "../Tooltips/TooltipGraphBarComposed";

const GraphBarComposed = ({ data, labelTooltip, fills }) => {
    const [mouseHover, setMouseHover] = React.useState(false);
    const [ttposition, setttposition] = React.useState({ x: 0, y: 0 });
    const columnRef = React.useRef(null);

    const MaxNumber = data && data.results ? Math.max(...data.results.map(r => {
        let tot = 0;
        data.subsections.forEach(s => {if (s) {tot += r[s];}});
        return tot;
    })) : 0;

    React.useEffect(() => {
        if (mouseHover) {
            const x = columnRef.current.offsetLeft;
            const y = columnRef.current.offsetTop;
            const w = columnRef.current.clientWidth;
            const h = columnRef.current.clientHeight;
            setttposition({ x, y, w, h });
        }
    }, [mouseHover]);

    return (
        <div className="graph-bar-composed" style={{ fontSize: "14px", fontWeight: "400", justifyContent: "end", padding: "20px 0px", width: "100%" }}>
            <div
                style={{ width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between", flexGrow: 1 }}>
                {data && data.results ? data.results.map((column, columnIndex) => {
                    let emptyh = MaxNumber;
                    let sindexFirst = -1;
                    let sindexLast = data.subsections.length;
                    data.subsections.forEach((s, si) => {
                        if (s && column[s]) {
                            sindexFirst = Math.max(sindexFirst, si);
                            sindexLast = Math.min(sindexLast, si);
                            emptyh -= column[s];
                        }
                    });
                    return <React.Fragment key={columnIndex}>
                        <div
                            ref={mouseHover === columnIndex + 1 ? columnRef : null}
                            style={{ display: "flex", height: "100%", flexDirection: "column", width: "100%", alignItems: "center", justifyContent: "end" }}
                            onMouseEnter={() => {if (emptyh !== MaxNumber) {setMouseHover(columnIndex + 1);}}}
                            onMouseLeave={() => setMouseHover(false)}
                        >
                            <div style={{ display: "flex", width: "8px", marginLeft: "2px", marginRight: "2px", flexGrow: emptyh }}/>
                            {
                                data.subsections.map((s, sIndex) => {
                                    return <div key={sIndex}
                                        style={{
                                            display: "flex", width: "8px",
                                            flexGrow: column[s], backgroundColor: fills[sIndex % (fills.length - 1)],
                                            borderRadius: (sIndex === sindexLast ? "5px 5px " : "0px 0px ") + (sIndex === sindexFirst ? "5px 5px" : "0px 0px")
                                        }}
                                    />;
                                })
                            }
                            <span style={{ color: "var(--carbone)", paddingTop: "4px" }}>{data.results.length <= 31 ? column.short : ""}</span>
                        </div>
                    </React.Fragment>;
                }) : null}
            </div>
            {mouseHover ?
                <div style={{
                    position: "absolute", zIndex: "1500",
                    left: mouseHover <= data.results.length / 2 ? `${ttposition.x + ttposition.w / 2 + 6}px` : null,
                    right: mouseHover > data.results.length / 2 ? `${18 + ttposition.w * ( data.results.length - mouseHover + 0.5) + 6}px` : null,
                    top: `${ttposition.y}px`,
                    height: `${ttposition.h}px`,
                    pointerEvents: "none",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyItems: "center",
                    justifyContent: "center"
                }}>
                    <TooltipGraphBarComposed
                        payload={data.results[mouseHover - 1]}
                        labelTooltip={labelTooltip}
                        subsections={data.subsections}
                        subdatas={data.subdatas}
                        fills={fills}/>
                </div> : null
            }
        </div>
    );
};

export default GraphBarComposed;
